export interface CatalogTaxonomyNode {
  label: string;
  matchGenres?: string[];
  matchStyles?: string[];
  children?: CatalogTaxonomyNode[];
}

export const CATALOG_TAXONOMY: CatalogTaxonomyNode[] = [
  { label: 'Hip-Hop', matchGenres: ['Hip-Hop'] },
  { label: 'Reggaeton', matchGenres: ['Reggaeton'] },
  { label: 'Pop', matchGenres: ['Pop'] },
  { label: 'Latin Pop', matchGenres: ['Latin Pop'] },
  {
    label: 'EDM',
    matchGenres: ['EDM'],
    children: [
      { label: 'Big Room', matchStyles: ['Big Room'] },
      { label: 'Festival EDM', matchStyles: ['Festival EDM'] },
      { label: 'Dance / Pop EDM', matchStyles: ['Dance / Pop EDM', 'Dance Pop EDM', 'Pop EDM'] },
      { label: 'Progressive EDM', matchStyles: ['Progressive EDM'] },
      { label: 'Trap / Festival Trap', matchStyles: ['Trap / Festival Trap', 'Festival Trap', 'Trap'] },
      { label: 'Moombahton', matchStyles: ['Moombahton'] }
    ]
  },
  {
    label: 'House',
    matchGenres: ['House'],
    children: [
      { label: 'Tech House', matchStyles: ['Tech House'] },
      { label: 'Deep House', matchStyles: ['Deep House'] },
      { label: 'Afro House', matchStyles: ['Afro House'] },
      { label: 'Bass House', matchStyles: ['Bass House'] },
      { label: 'Future House', matchStyles: ['Future House'] },
      { label: 'Progressive House', matchStyles: ['Progressive House'] },
      { label: 'Electro House', matchStyles: ['Electro House'] },
      { label: 'Classic House', matchStyles: ['Classic House'] }
    ]
  },
  { label: 'Latin Dance-EDM', matchGenres: ['Latin Dance-EDM'] },
  {
    label: 'Cumbias',
    matchGenres: ['Cumbia', 'Cumbias'],
    children: [
      { label: 'Cumbia Clásica', matchStyles: ['Cumbia Clasica', 'Cumbia Clásica'] },
      { label: 'Cumbia Sonidera', matchStyles: ['Cumbia Sonidera'] },
      { label: 'Cumbia Texana', matchStyles: ['Cumbia Texana'] }
    ]
  },
  {
    label: 'Regional Mexicano',
    matchGenres: ['Regional Mexicano'],
    children: [
      {
        label: 'Banda',
        matchStyles: ['Banda'],
        children: [
          { label: 'Banda Romántica', matchStyles: ['Banda Romantica', 'Banda Romántica'] },
          { label: 'Banda Movida', matchStyles: ['Banda Movida'] }
        ]
      },
      { label: 'Corridos', matchStyles: ['Corridos'] },
      { label: 'Duranguense', matchStyles: ['Duranguense'] },
      {
        label: 'Norteña',
        matchStyles: ['Nortena', 'Norteña'],
        children: [
          { label: 'Norteñas con Sax', matchStyles: ['Nortenas con Sax', 'Norteñas con Sax'] },
          { label: 'Balada Norteña', matchStyles: ['Balada Nortena', 'Balada Norteña'] }
        ]
      },
      {
        label: 'Quebradita',
        matchStyles: ['Quebradita'],
        children: [
          { label: 'Quebradita', matchStyles: ['Quebradita'] },
          { label: 'Quebraditas Remix', matchStyles: ['Quebraditas Remix'] }
        ]
      },
      { label: 'Ranchera', matchStyles: ['Ranchera'] },
      { label: 'Zapateado', matchStyles: ['Zapateado'] },
      { label: 'Huapango', matchStyles: ['Huapango', 'Huapangos'] },
      { label: 'Tierra Caliente', matchStyles: ['Tierra Caliente'] },
      { label: 'Chilenas', matchStyles: ['Chilenas'] }
    ]
  },
  { label: 'Guaracha', matchGenres: ['Guaracha'] },
  { label: 'Dembow', matchGenres: ['Dembow'] },
  { label: 'Bachata', matchGenres: ['Bachata'] },
  { label: 'Merengue', matchGenres: ['Merengue'] },
  { label: 'Salsa', matchGenres: ['Salsa'] }
];

export function collectTaxonomyGenres(nodes = CATALOG_TAXONOMY) {
  const genres = new Set<string>();
  for (const node of nodes) {
    node.matchGenres?.forEach((genre) => genres.add(genre));
    collectTaxonomyGenres(node.children || []).forEach((genre) => genres.add(genre));
  }
  return genres;
}

export function collectTaxonomyStyles(nodes = CATALOG_TAXONOMY) {
  const styles = new Set<string>();
  for (const node of nodes) {
    node.matchStyles?.forEach((style) => styles.add(style));
    collectTaxonomyStyles(node.children || []).forEach((style) => styles.add(style));
  }
  return styles;
}
